import { useI18n } from 'vue-i18n';

/**
 * Composable for lazy loading i18n locales
 * Apps should register their loadLocale function using window.__r7e_loadLocale
 */
export function useLocaleLoader() {
  const { locale } = useI18n();

  /**
   * Load a locale if it's not already loaded
   * @param {string} targetLocale - The locale code to load (e.g., 'fr', 'de', 'es')
   * @returns {Promise<void>}
   */
  const loadLocaleIfNeeded = async (targetLocale) => {
    // Use the registered loadLocale function (this handles lazy loading and checks if already loaded)
    if (window.__r7e_loadLocale && typeof window.__r7e_loadLocale === 'function') {
      await window.__r7e_loadLocale(targetLocale);
      return;
    }

    // Fallback: try to switch anyway (might work if locale was loaded elsewhere)
    locale.value = targetLocale;
  };

  return {
    loadLocaleIfNeeded,
  };
}

